import { useRef, useContext } from "react";
import { ChevronDownSvg } from "../../icons/Icon";
import { useEventContext } from "../../contexts/EventContextProvider";
import VariantDiscountsDisplayBar from "./VariantDiscountsDisplayBar";
import { PlaceholderContext } from "../../contexts/Contexts";
import {
    viewDiscountsByVariantIdEvent,
    enableVariantDiscountEditEvent,
    deleteAllDiscountsByVariantId
} from "../../events/VariantDiscountsEditorEvents";
import { Dialog } from "../modal/Dialog";

const VariantList = ({ items, onCheck, checked }) => {

    const { state, eventDispatch } = useEventContext();
    const placeholder = useContext(PlaceholderContext);
    const rows = useRef({});

    const onDelete = (e, o) => {
        e.preventDefault();

        placeholder.openModal(<Dialog><div>Delete all discounts from variant "<b>{o.name}</b>" ?</div></Dialog>, {
            onApprove: (a) => {
                deleteAllDiscountsByVariantId(o?.id || null);
                a.actions.close();
            }
        }, {
            heading: 'Confirm delete',
            message: ''
        })
    };

    return (
        <div className="filter-list">
            {items &&
                items.map((item) => {
                    return (
                        <div key={`variant-tag-${item.id}`} className={`StickerItem ${checked[item.id] ? 'CollectionList_SelectedRow' : ''}`}>
                            <div className="flex-column">
                                <div className="flex-row">
                                    <div className="col-1 flex-center">
                                        <label className="StickerItem_label">
                                            <div className="StickerItem_tag">
                                                <input
                                                    type="checkbox"
                                                    name="variant"
                                                    onChange={(e) => onCheck(e, item)}
                                                    checked={checked[item.id] || false}
                                                />
                                            </div>
                                        </label>
                                    </div>
                                    <div className="col-19 flex-middle">
                                        <div className="StickerItem_tag">
                                            <span>{item.name}</span>
                                        </div>
                                    </div>
                                    <div className="col-3 flex-middle">
                                        <div className="StickerItem_controls" >
                                            <button onClick={(e) => eventDispatch(enableVariantDiscountEditEvent(item))}><span>edit</span></button>
                                            <button onClick={(e) => onDelete(e, item)}><span>delete</span></button>
                                        </div>
                                    </div>
                                    <div className="col-1 flex-middle">
                                        <div className="StickerItem_controls" >
                                            <button onClick={(e) => eventDispatch(viewDiscountsByVariantIdEvent(item))}><span><ChevronDownSvg /></span></button>
                                        </div>
                                    </div>
                                </div>
                                <VariantDiscountsDisplayBar id={item.id} ref={(current => { rows.current[item.id] = current })} />
                            </div>
                        </div>
                    );
                })}
        </div>
    );
}

export default VariantList;